import { actionTypes } from '../actions/menuModal';

export const menuModalInitialState = {
  isShow: false,
  isSearchActive: false,
  searchQuery: '',
};

export default (state = menuModalInitialState, { type, payload }) => {
  switch (type) {
    case actionTypes.OPEN:
      return { ...state, isShow: true };
    
    case actionTypes.CLOSE:
      return { ...state, isShow: false };

    case actionTypes.TOGGLE_SEARCH:
      return { ...state, isSearchActive: payload };

    case actionTypes.CHANGE_SEARCH_QUERY:
      return { ...state, searchQuery: payload };
  
    default:
      return state;
  }
};
